<div class="ai-prevention-page">
  @if (isLoading()) {
    <div class="policy-spinner">
      <mat-progress-spinner color="primary" mode="indeterminate"> </mat-progress-spinner>
    </div>
  }

  @if (isLoading() === false) {
    <div class="scollable-tables">
      @if (isAccountAuthorizedToViewMockPrevention) {
        <app-enterprise-ai-prevention-mock></app-enterprise-ai-prevention-mock>
      } @else {
        <div class="unauthorized-access">
          <p>You don't have access to view this page.</p>
        </div>
      }
    </div>
  }
</div>
